/** Межа тривалості дзвінка. Переноситься з мобільних клієнтів без змін. */
export const CALL_LIMIT_MS = 60 * 60 * 1000;

/**
 * Формат збігається з мобільним клієнтом (`_formatLongTime`): години
 * зʼявляються, лише коли вони є, тож на старті це `01:00:00`, а не `60:00`.
 */
export function formatRemaining(remainingMs: number): string {
  const totalSeconds = Math.floor(Math.max(0, remainingMs) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (value: number): string => String(value).padStart(2, '0');
  return hours > 0
    ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    : `${pad(minutes)}:${pad(seconds)}`;
}
